<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
            size="lg"
            v-model="infoVat.show"
            @hidden="closeModal()"
        >
            <card shadow type="secondary" class="m--4">
                <span class="close cursor-pointer" @click="infoVat.show = false">&times;</span>
                <div class="row">
                    <div class="col-12 text-center">
                        <h3>วิธีการคิดภาษีมูลค่าเพิ่มขนส่ง</h3>
                    </div>
                    <div class="col-12">
                        <b-alert show variant="info-vat" class="px-0">
                            <div class="row">
                                <div class="col-6 pr-0 text-left">
                                    <i class="far fa-check-circle text-success"></i>
                                    <span class="h4">
                                        หาก<span class="text-primary">เลือกทำการคิด</span>ภาษีมูลค่าเพิ่มขนส่ง<br/>
                                        <span class="pl-4">ภาษีมูลค่าเพิ่มจะถูกคำนวณจาก<span class="text-primary">ค่าบริการและค่าขนส่งรวมกัน</span></span>
                                    </span>
                                </div>
                                <div class="col-6 pr-0 text-left">
                                    <i class="far fa-check-circle text-success"></i>
                                    <span class="h4">
                                        หาก<span class="text-primary">เลือกไม่ทำการคิด</span>ภาษีมูลค่าเพิ่มขนส่ง<br/>
                                        <span class="pl-4">ภาษีมูลค่าเพิ่มจะถูกคำนวณจาก<span class="text-primary">ค่าบริการเท่านั้น</span></span>
                                    </span>
                                </div>
                            </div>
                        </b-alert>
                    </div>
                    <div class="col-6">
                        <label>ตัวอย่าง :</label>
                        <CardReceiptCourier />
                        <div class="p-2">
                            <span>
                                ภาษีมูลค่าเพิ่ม จะถูกคิดเป็น 7% จากค่าขนส่ง 20 บาท รวมกับค่าบริการอื่นๆ 10 บาท เป็นจำนวนเงิน <span class="h4 text-primary">1.96 บาท</span>
                            </span>
                        </div>
                    </div>
                    <div class="col-6">
                        <label>ตัวอย่าง :</label>
                        <CardReceipt />
                        <div class="p-2">
                            <span>
                                ภาษีมูลค่าเพิ่ม จะถูกคิดเป็น 7% จากค่าบริการอื่นๆ 10 บาท เพียงอย่างเดียว เป็นจำนวนเงิน <span class="h4 text-primary">0.65 บาท</span>
                            </span>
                        </div>
                    </div>
                    <div class="w-100 text-center pt-4">
                        <b-button variant="primary" class="w-25" @click="closeModal()">ปิด</b-button>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
import Card from '../Card.vue';
import CardReceiptCourier from '../custom/receipt/CardReceiptCourier.vue';
import CardReceipt from '../custom/receipt/CardReceipt.vue';
export default {
    name: "ModalInfoVatShop",
    props: {
        infoVat: Object,
    },
    methods: {
        closeModal() {
            this.infoVat.show = false;
        },
    },
    components: { Card, CardReceiptCourier, CardReceipt }
}
</script>
